import { useQuery } from '@tanstack/react-query'
import { datasetsPreloadAnalyzeCreate } from '../../../../api/generated/endpoints/databook/databook'

const usePreloadDatasetSummary = (dataset) => {
  return useQuery({
    queryKey: [
      'preloadDatasetSummary',
      dataset?.name,
      dataset?.records?.length,
      dataset?.id,
      dataset?._searchId,
    ],
    queryFn: async () => {
      const response = await datasetsPreloadAnalyzeCreate(dataset, {
        action: 'summary',
      })
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: !!dataset && !!dataset.records,
  })
}

export default usePreloadDatasetSummary
